import ChartRangeView, { ChartRangeViewProps } from '../ChartRangeView/ChartRangeView'
import styles from './ChartRangeViewPortrait.module.less'
import cls from 'classnames'

function ChartRangeViewPortrait(props: ChartRangeViewProps) {
  return (
    <ChartRangeView
      {...props}
      thumbnailMode='portrait'
      className={cls(styles.chartRangeViewPortrait, props.className)}
    />
  )
}

export default ChartRangeViewPortrait
